<script lang="ts">
	import Toast from './Toast.svelte'
	import type { ToastModel } from '$lib_commons/models/toast-model.ts'
	import { writable, type Writable } from 'svelte/store'
	import { dismissToast } from '../utils/toast'
	import { expand } from '@repo/commons/utils'
	import { portal } from 'svelte-portal'

	interface Props {
		toastsStore?: Writable<ToastModel[] | null>
	}

	let { toastsStore = writable(null) }: Props = $props()
</script>

{#if $toastsStore}
	<section use:portal={'body'}>
		{#each $toastsStore as toast (toast.id)}
			<div in:expand={{ duration: 200 }} out:expand={{ duration: 200, delay: 300 }}>
				<Toast
					toastType={toast.type}
					compact={!toast.heading}
					dismissible={toast.dismissible}
					onDismiss={() => dismissToast(toastsStore, toast.id)}
					toastIcon={toast.toastIcon}
					actionLabel={toast.actionLabel}
					onAction={toast.onAction}
					fullWidth={toast.fullWidth}
				>
					{#snippet heading()}
						{#if toast.heading}
							<div>{toast.heading}</div>
						{/if}
					{/snippet}
					{#snippet text()}
						<div>{@html toast.message}</div>
					{/snippet}
				</Toast>
			</div>
		{/each}
	</section>
{/if}

<style lang="postcss">
	section {
		position: fixed;
		bottom: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin: 1rem;
		z-index: 1000;
	}
</style>
